import React, { useState } from "react";
import FormFieldsLayout from "../ContactForms/common/FormBox";
import NumberFormat from "react-number-format";
import { unformatPhoneNumber } from "../../utils/text";
import { Button } from "../Buttons";
import { Input, Box, Checkbox, useToast } from "@chakra-ui/core";
import axios from "axios";
import ButtonGroup from "../ButtonGroup"

import "./style.css";

const CustomPhoneInput = React.forwardRef(({ value, ...props }: any, ref: any) => (
  <Input
    {...props}
    ref={ref}
    value={value}
    color={value ? "black" : "gray.500"}
    _placeholder={{ color: "gray.500" }}
  />
));
CustomPhoneInput.displayName = "CustomPhoneInput";

export default function BikeExpertForm({title, pageURL}: {title:string, pageURL:string}) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    contactPreference: "email",
    title,
    pageURL,
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const toast = useToast();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handlePhoneChange = (values: any) => {
    setFormData((prev) => ({
      ...prev,
      phone: values.formattedValue,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await axios.post("/.netlify/functions/contactBikeExpert", formData);
      toast({
        title: "Success",
        description: "Form submitted successfully.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      setFormData({
        name: "",
        email: "",
        phone: "",
        contactPreference: "",
        title,
        pageURL,
      });
      setFormSubmitted(true);
    } catch (error) {
      console.error("Submission error:", error);
      toast({
        title: "Error",
        description: "Something went wrong.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box as="form" onSubmit={handleSubmit} className="bike_expert_form-container">
      <label
        style={{
          alignItems: 'center',
          fontWeight: '600'
        }}
      >Our bike experts are here to help you find perfect fit!<br />Just choose how you'd like to chat below.</label>
      <FormFieldsLayout className="bike_expert_form-fields_group">
        {!formSubmitted ? (
          <>
            <Box className="row">
              <Input
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
              />
            </Box>
            <Box className="row">
              <Input
                name="email"
                placeholder="Email address"
                type="email"
                isRequired
                value={formData.email}
                onChange={handleChange}
              />
            </Box>
            <Box className="row">
              <NumberFormat
                name="phone"
                type="tel"
                format="(###) ###-####"
                allowEmptyFormatting
                mask="_"
                placeholder="Phone"
                value={formData.phone}
                onValueChange={handlePhoneChange}
                customInput={CustomPhoneInput}
              />
            </Box>

            <Box
              className="row"
              justifyContent="flex-start !important"
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                flexWrap: 'nowrap',
                paddingLeft: '1rem',
                gap: '1.5rem', // default for desktop
              }}
              id="contact-preference-row"
            >
              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  whiteSpace: 'nowrap',
                }}
              >
                Contact Preference:
              </label>

              <Box
                display="flex"
                alignItems="center"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1.5rem',
                  flexWrap: 'nowrap',
                }}
              >
                <label
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    cursor: 'pointer',
                  }}
                >
                  <input
                    type="radio"
                    name="contactPreference"
                    value="email"
                    checked={formData.contactPreference === 'email'}
                    onChange={handleChange}
                    style={{
                      accentColor: 'black',
                      width: '1.2rem',
                      height: '1.2rem',
                      cursor: 'pointer',
                    }}
                  />
                  <span style={{ fontSize: '1rem', color: '#000', whiteSpace: 'nowrap' }}>
                    Email
                  </span>
                </label>

                <label
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    cursor: 'pointer',
                  }}
                >
                  <input
                    type="radio"
                    name="contactPreference"
                    value="text"
                    checked={formData.contactPreference === 'text'}
                    onChange={handleChange}
                    style={{
                      accentColor: 'black',
                      width: '1.2rem',
                      height: '1.2rem',
                      cursor: 'pointer',
                    }}
                  />
                  <span style={{ fontSize: '1rem', color: '#000', whiteSpace: 'nowrap' }}>
                    Text
                  </span>
                </label>
              </Box>
            </Box>
            <style>{`
              @media (max-width: 600px) {
                #contact-preference-row {
                  gap: 0.75rem !important;
                  padding-left: 0.5rem !important;
                }

                #contact-preference-row label span {
                  font-size: 0.95rem;
                }
              }
            `}</style>

            <Box className="row" textAlign="center">
              <Button theme="primary" type="submit">
                Submit
              </Button>
            </Box>
          </>
        ) : (
          <p>Our bike experts will contact you soon!</p>
        )
      }
      </FormFieldsLayout>
    </Box>
  );
}
